module.exports = __webpack_public_path__ + "static/media/drive-menu.1360ae81.svg";